import { useI18n } from "i18n";
import { Dialog } from "@remo-co/ui-core/src/components/Dialog";
import { DialogActions } from "@remo-co/ui-core/src/components/DialogActions";
import { DialogContent } from "@remo-co/ui-core/src/components/DialogContent";
import { IconButtonWithTooltip } from "@remo-co/ui-core/src/components/IconButtonWithTooltip";
import { useSelector } from "react-redux";
import { Close } from "@remo-co/ui-core/src/icons/Close";
import { selectIsMobile } from "modules/deviceInfo";
import { useAppDispatch } from "store/hooks";
import { hideCameraSettingsDialog } from "modules/cameraSettings/redux/actions";
import { AudioVideoSettings } from "../Container";

export const AudioVideoSettingsDialog = () => {
  const dispatch = useAppDispatch();
  const handleHideCameraSettingsDialog = () =>
    dispatch(hideCameraSettingsDialog());

  const { t } = useI18n();
  const isMobileView = useSelector(selectIsMobile);

  return (
    <Dialog
      fullScreen={isMobileView}
      open
      maxWidth={false}
      data-testid="audio-video-settings-dialog"
    >
      <DialogActions>
        <IconButtonWithTooltip
          id="close-camera-settings-dialog"
          title={t("button.close")}
          onClick={handleHideCameraSettingsDialog}
        >
          <Close />
        </IconButtonWithTooltip>
      </DialogActions>
      <DialogContent>
        <AudioVideoSettings />
      </DialogContent>
    </Dialog>
  );
};
